// src/components/DynamicSetupWizard/Stepper.tsx
import React from "react";
import type { Step } from "store/integrations/types";

interface StepperProps {
  steps: Step[];
  currentIndex: number;
}

export default function Stepper({ steps, currentIndex }: StepperProps) {
  return (
    <div className="d-flex justify-content-between align-items-center">
      {steps.map((step, idx) => {
        const isDone   = idx < currentIndex;
        const isActive = idx === currentIndex;
        const bgClass  = isDone
          ? "bg-success text-white"
          : isActive
          ? "bg-primary text-white"
          : "bg-primary-subtle text-muted";

        return (
          <div key={step.id} className="flex-fill text-center">
            <div
              className={`mx-auto ${bgClass} rounded-circle d-flex align-items-center justify-content-center`}
              style={{ width: 48, height: 48 }}
            >
              {isDone ? (
                <i className="ri-checkbox-circle-fill" style={{ fontSize: 20 }} />
              ) : (
                <span className="fw-bold" style={{ fontSize: 16 }}>{idx + 1}</span>
              )}
            </div>
            <div className={`${isActive ? "text-primary fw-bold" : "text-muted"} mt-2 small`}>
              {step.title}
            </div>
          </div>
        );
      })}
    </div>
  );
}
